import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../service/http.service';
import { Language } from '../language';
import { LeadEmailTemplate } from '../lead-email-template';

@Component({
  selector: 'app-lead-email-templates',
  templateUrl: './lead-email-templates.component.html',
  styleUrls: ['./lead-email-templates.component.css']
})
export class LeadEmailTemplatesComponent implements OnInit {

  templates!: Observable<LeadEmailTemplate[]>;
  selectedLanguage!: Language;
  languages: Language[] = [];

  constructor(
    private httpService: HttpService
  ) { }

  ngOnInit(): void {
    this.templates =  this.httpService.getLeadEmailTemplatesByLanguage(new Language(1, "French"));
    this.templates.subscribe(res => {
      console.log(res);
    });
    this.httpService.getLanguages().subscribe(res => {
      this.languages = res;
      this.selectedLanguage = this.languages[0];
    });
  }

  updateTemplateList(){
    this.templates = this.httpService.getLeadEmailTemplatesByLanguage(this.selectedLanguage);
  }

}
